import { render } from "./MessageDetail.vue?vue&type=template&id=0bcbb992"
import script from "./MessageDetail.vue?vue&type=script&lang=js"
export * from "./MessageDetail.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MessageDetail.vue?vue&type=style&index=0&id=0bcbb992&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__